import React, { useState, useEffect } from "react"
import ScrollAnimation from "react-animate-on-scroll"
import getVideoId from "get-video-id"
import SearchResultsImagePopup from "@Components/SearchResults/SearchResultsImagePopup"
import SearchResultsFloorplanPopup from "@Components/SearchResults/SearchResultsFloorplanPopup"
import PlayVideo from "@Components/PlayVideo/PlayVideo"
import { useWindowSize } from "../hooks/window-size"
import Valuation from "@Components/SearchResults/Valuation/Valuation"
import NewHomesLink from "@Components/SearchResults/NewHomesLink"
import { ShowProcessedImage } from "@Components/common/ggfx-client/module/components/show-image"
import imageConfig from "../../static/images/config.json"
import NoImage from "../images/no_image_new_homes.webp"
import Content from "../Components/Content/Content"
import { Link } from "gatsby"
import { Form, Container, Row, Col, Fade, Modal } from "react-bootstrap"

import {
  UserObjectStoreProvider,
  SaveItem,
  getUserobjectData,
  isAuthenticated,
  savedSearchParams,
} from "@myaccount/website-service"


export const InfiniteHits = ({
    hits,
    hasPrevious,
    refinePrevious,
    hasMore,
    refineNext,
    location,
  }) => {
    const [isPlay, setIsPlay] = useState(false)
    const [videoid, setVideoId] = useState("")
    const [video_type, setVideoType] = useState("")
  
    const playVideoHandler = (video_url, video_type) => {
      setIsPlay(true)
      setVideoId(video_url)
      setVideoType(video_type)
    }
  
    const [show, setShow] = useState(false)
    const [fullscreen, setFullscreen] = useState(true)
  
    function handleShow(video_url, video_type) {
      setShow(true)
      setVideoId(video_url)
      setVideoType(video_type)
    }
  
    useEffect(() => {
      if (typeof window !== undefined) {
        if (window.scrollY) {
          window.scroll(0, 0)
        }
      }
    }, [])
  
  
    console.log(hits,"gnm,")
  
    return (
      <>
        {hits.length > 0 && hasPrevious && (
          <button
            id="myprevbut"
            onClick={refinePrevious}
            disabled={!hasPrevious}
            className="d-none property_show_more_btn"
          >
            Show prev
          </button>
        )}
  
        {hits.map((hit, i) => {
          // property details url structure
          let uriStr = ""
          let mysale = ""
  
          if (
            hit.search_type === "sales" &&
            hit.department === "newdevelopments"
          ) {
            uriStr = `new-home-for-sale/`
            mysale = `myResSaleProp`
          }
          // property details url structure
  
          // Video id
          let videotourid = hit.video_tour && getVideoId(hit.video_tour)
  
          let virtualid = hit.virtual_url && getVideoId(hit.virtual_url)
          // Video
  
          var display_address_val = hit.display_address
          const streetName=hit.display_address?.split(",")
          let propAddress=hit.display_address?.split(",")
          propAddress?.shift()

          var developer_logo = hit?.developer_logo || hit?.developer_logo2
  
  
          return (
            <>
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                <div className="property-card-detailed">
                  <div className="property-img">
                    <Link to={`/${uriStr}${hit.slug}-${hit.objectID}`}>
                      {/* <picture>
                        <source
                          media="(min-width: 1200px)"
                          srcSet={hit.images[0]["600x400"]}
                        />
                        <ShowProcessedImage
                              images={hit.images[0]}
                              attr={{
                                className: "mb-0 img-fluid",
                                alt: `${hit.display_address} - DNG Estate Agents`,
                              }}
                              transforms={
                                imageConfig["new-developments"].searchResults.sizes
                              }
                            />
                        {/* <img
                          src={hit.images[0]["352x244"]}
                          alt={`${hit.display_address} - DNG Estate Agents`}
                        /> 
                      </picture> */}
                      {/* <img src={resultImg2} alt="property" /> */}

                      {hit.images && hit.images?.length > 0 ?
                      <picture>
                        <source
                          media="(min-width: 1200px)"
                          srcSet={hit.images[0]["600x400"]}
                        />
                        <ShowProcessedImage
                              images={hit.images[0]}
                              attr={{
                                className: "mb-0 img-fluid",
                                alt: `${hit.display_address} - DNG Estate Agents`,
                              }}
                              transforms={
                                imageConfig["new-developments"].searchResults.sizes
                              }
                            />
                        {/* <img
                          src={hit.images[0]["352x244"]}
                          alt={`${hit.display_address} - DNG Estate Agents`}
                        /> */}
                      </picture>
                      :
                      <img src={NoImage} alt={`${hit.display_address} - DNG Estate Agents`} />
                      }
                    </Link>
  
                    <div className="property-wrapper">
                      <div className="left-block">
                       
                        {hit?.images && hit?.images?.length != 0 && (
                          <SearchResultsImagePopup
                            propertyId={hit.objectID}
                            propertyImage={hit?.images}
                            department="new_homes"
                            imageCount={hit?.imageCount}
                          />
                        )}
  
                        <div className="property-view">
                       
  
                          {hit.video_tour &&
                            (videotourid?.service === "youtube" ? (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    playVideoHandler(hit.video_tour, "youtube")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ) : (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    handleShow(hit.video_tour, "custom_video")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ))}
  
                          {hit.virtual_url &&
                            (virtualid?.service === "youtube" ? (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    playVideoHandler(hit.virtual_url, "youtube")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ) : (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    handleShow(hit.virtual_url, "custom_video")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ))}
  
                          {hit?.floorplan?.url && (
                            <SearchResultsFloorplanPopup
                              propertyId={hit.objectID}
                              propertyFloorPlan={hit?.floorplan}
                              
                            />
                          )}
                        </div>
                      </div>
                      {/* <div className="right-block">
                        <button>
                          <i className={"icon-heart"} />
                          <span className="span-btn-text">{"save"}</span>
                        </button>
                      </div> */}
                    </div>
                    {hit.status &&
                      hit.status !== "For Sale" &&
                      hit.status !== "To Let" && (
                        <div className="property-tag">{hit.status}</div>
                      )}
                  </div>
                  <div className="property-details">
                    <div className="name-wrap">
                      <div className="property-name">
                        <Link to={`/${uriStr}${hit.slug}-${hit.objectID}`}>
                          {streetName &&
                            streetName[0]
                            }
                          {/*<br className="d-none d-xl-block" />{'test2'}*/}
                        </Link>
                        <p style={{marginTop:"15px"}}></p>
                        <Link to={`/${uriStr}${hit.slug}-${hit.objectID}`}>
                          {propAddress &&
                            
                            propAddress.join(",").replace(/,,/g, ",")
                            }
                          {/*<br className="d-none d-xl-block" />{'test2'}*/}
                        </Link>
                      </div>
                      {developer_logo &&
                      <div className="img-wrap">
                        <img src={developer_logo} alt="logo - DNG Estate Agents" />
                      </div>
                      }
                    </div>
                    {/* <p>
                      {hit.title && `${capitalize(hit.title)}`}
                      {parseInt(hit?.available) > 0 && (
                        <span className="available-properties">
                          ${hit.available} Available
                        </span>
                      )}
                    </p> */}
  
                    <div className="property-price">
                      {hit?.price_qualifier === "POA"
                        ? "€ Price on Application"
                        : hit.price_qualifier==="Guide price"
                          ?`From €${parseFloat(hit.price).toLocaleString()}`:
                           hit?.price === hit?.max_price
                          ? `From €${parseFloat(hit.price).toLocaleString()}`
                          :
                            hit.price>10000?
                           `€${parseFloat(hit.price).toLocaleString()} to 
                           €${parseFloat(hit.max_price!==0?hit.max_price:hit.price).toLocaleString()}     
                            `
                            :"€ Price on Application"
                           }
                    </div>
  
                    <div className="new-homes-height">
                    {hit.description && (
                      // <p className="more-info">{hit.description}</p>
                      // <ReactMarkdown source={hit.description} allowDangerousHtml className="des-text"/>
                            <Content
                              Content={hit.description}
                              page="new-search-result"
                              // uriStr={uriStr}
                              // hit={hit}
                            />
                     )
                  } 
                  </div>
                    <div className="links-block">
                      <div className="link-wrap">
                        <Link to={`/${uriStr}${hit.slug}-${hit.objectID}`}>
                          View Details
                          <i className="icon-arrow"></i>
                        </Link>
                      </div>
  
                      <NewHomesLink
                        hit={hit}
                        pro_url={`/${uriStr}${hit.slug}-${hit.objectID}`}
                      />
                    </div>
                  </div>
                </div>
              </ScrollAnimation>
  
              {(i + 1) % 4 === 0 ? <Valuation /> : ""}
            </>
          )
        })}
  
        {hits.length > 0 && hasMore && (
          <section className="more-results w-100 pb-4">
            <div className="more-btn">
              <button
                className="btn"
                id="mynextbut"
                onClick={refineNext}
                disabled={!hasMore}
              >
                Load More
              </button>
            </div>
          </section>
        )}
      </>
    )
  }